var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full h-full"},[_c('v-chart',{ref:"pieChartRef",staticClass:"w-full !h-full",attrs:{"options":_vm.realtimeMonitoringData,"autoresize":true,"init-options":{ devicePixelRatio: 2 }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }